<template>
  <div id="app">
  	<keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import {ajax} from '@/request'
export default {
  name:'app',
  data(){
    return {
    }
  },
  mounted(){
      // 3、活动奖品：一等奖50名，奖品是加湿器；二等奖200名，奖品是种子纸台历；三等奖500名，奖品是环保手提袋。
      localStorage.jp = JSON.stringify([{
        drawLevel:'一等奖',
        num:50,
        // money:'价值200元',
        name:'加湿器',
        url:'https://bm.dahe.cn/wxbanswer/img/level1.png',
      },
      {
        drawLevel:'二等奖',
        num:200,
        // money:'价值100元',
        name:'种子纸台历',
        url:'https://bm.dahe.cn/wxbanswer/img/level2.png',
      },
      {
        drawLevel:'三等奖',
        num:600,
        // money:'价值20元',
        name:'环保手提袋',
        url:'https://bm.dahe.cn/wxbanswer/img/level3.png',
      }])

    if(!getCurrentEnvironment()){
      this.$router.replace({
        path:'/404'
      })
      return 
    }
    this.wx_auth()
    // localStorage.q = 'oXGEpwZQg0Kt5_cmz0AKXtkZj6Zk'
    // localStorage.q = 'oPCeewqZgkq2tY69YWdBDS76N-wg'
    // localStorage.nickname = '烟花易冷'
    // localStorage.userWinning = '-1'
    this.getconfig()


  },
  methods: {
    // 注册
    getconfig(){
        var localhref = window.location.href.split('#')[0];
        let url = encodeURIComponent(localhref)
        let that = this
        ajax('share/dahe?url='+url,'',{type:'get',changeBaseURL:true,baseURL:'https://share.dahe.cn/'}).then(res=>{
            if(res.result == 200){
                let text = res.object
                wx.config({
                    debug: false, // 开启调试模式
                    appId: text.appId, // 必填，公众号的唯一标识
                    timestamp: text.timestamp, // 必填，生成签名的时间戳
                    nonceStr: text.nonceStr, // 必填，生成签名的随机串
                    signature: text.signature,// 必填，签名
                    jsApiList: [
                      'updateAppMessageShareData',
                      'updateTimelineShareData',
                    ] // 必填，需要使用的JS接口列表
                })
                // 打开分享按钮
                wx.showOptionMenu()
                var tit = '“e法豫说”法律法规云答题活动';
                var des = '点击参与答题';
                // var icon = 'https://bm.dahe.cn/wxbanswer/img/fxlogo.png';
                var icon = 'https://bm.dahe.cn/wxbanswer/img/fx.png';
                that.wxshare(tit,des,icon,localhref)
            }
        })
    },
    // 分享
    wxshare(tit,des,icon,sharelink){
        var sharetitle= tit+"";
        var shareimgUrl= icon;
        var sharedes= des;
        wx.ready(function () {
            // 先关闭所有页面分享
            wx.showOptionMenu()
            wx.error(function (res) {
                // history.go()
            })
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
                title: sharetitle, // 分享标题
                link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareimgUrl, // 分享图标
                desc: sharedes, // 分享描述
                success: function() {
                    // 设置成功
                },
                fail:function (e) {
                }
            })
            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
                title: sharetitle, // 分享标题
                link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareimgUrl, // 分享图标
                success: function() {
                    // 设置成功
                },
                fail:function (e) {
                }
            })
        })
    },
    wx_auth(){
      let code = GetRequest().code
      if(code){
        // 拿到code 后就清空 避免刷新请求
        if(!localStorage.q){
          this.$store.dispatch('wx_auth',{code:code}).then(res=>{
            if(res.obj && res.obj.openId){
              localStorage.q = res.obj.openId
              localStorage.nickname = res.obj.nickname
              localStorage.userWinning = res.obj.userWinning
              localStorage.userAnswer = res.obj.userAnswer
            }else{
              this.$dialog.alert({
                title: '抱歉',
                message: '获取微信授权失败',
              })
              .then(() => {
                  // on confirm
                  localStorage.clear()
                  let url = encodeURIComponent('https://bm.dahe.cn/wxbanswer/')
                  window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx90cb4d32ca1105a2&redirect_uri='+url+'&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect','_self')
              })
            }
          }).catch(() => {
            this.$dialog.alert({
              title: '抱歉',
              message: '获取微信授权失败',
            })
            .then(() => {
                // on confirm
                localStorage.clear()
                let url = encodeURIComponent('https://bm.dahe.cn/wxbanswer/')
                window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx90cb4d32ca1105a2&redirect_uri='+url+'&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect','_self')
            })
          });
        }
      }else{
        if(!localStorage.q){
          let url = encodeURIComponent('https://bm.dahe.cn/wxbanswer/')
          window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx90cb4d32ca1105a2&redirect_uri='+url+'&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect','_self')
        }
      }
      //得到url参数
      function GetRequest() {
        var url = location.search; //获取url中"?"符后的字串
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            let strs = str.split("&");
            for(var i = 0; i < strs.length; i ++) {
                theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1]);
            }
        }
        return theRequest;
      }
    },
  },
}
function getCurrentEnvironment() {
  //判断当前页面的运行环境（微信/其他）
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true
  } else {
    return false
  }
}
</script>

<style lang="scss" scoped>
</style>
